export default __webpack_public_path__ + "static/media/2018.88cb0d04.png";